import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import "./titoliStudio.css";
import CustomSelect from "../CustomSelect";

const EditTitoliStudi = () => {
  const [loading, setLoading] = useState(true);
  const [titoliStudi, setTitoliStudi] = useState(null);
  const [tipologiaTitoli, setTipologiaTitoli] = useState([]);

  const [form, setForm] = useState({
    idTipologiaTitolo: "",
    nomeTitolo: "",
    rilasciatoIl: "",
    da: "",
  });

  const [errors, setErrors] = useState({});
  const [editMode, setEditMode] = useState(false);

  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const loadData = async () => {
    if (location.state?.titoliStudi) {
      const data = location.state.titoliStudi;

      setTitoliStudi(data);
      setForm({
        idTipologiaTitolo: data.tipologiaTitolo?.idTipologiaTitolo || "",
        nomeTitolo: data.nomeTitolo || "",
        rilasciatoIl: data.rilasciatoIl || "",
        da: data.da || "",
      });
      await fetchTipologiaTitoli();
    } else {
      toast.error("Dati titolo di studio non trovati!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "TRAINER") {
      alert("Accedi come docente per modificare i titoli di studio!");

      localStorage.clear();
      navigate("/login");
    } else {
      loadData();
      fetchTipologiaTitoli();
    }
  }, [navigate]);

  const fetchTipologiaTitoli = async () => {
    try {
      const response = await api.get("/tipologia-titoli");
      if (response.status === 200) {
        setTipologiaTitoli(response.data);
      } else {
        toast.error("Errore nel caricamento delle tipologie titolo.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error("Errore durante il recupero dei titoli:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "idTipologiaTitolo" ? Number(value) : value,
    }));

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (name === "nomeTitolo" && value.trim()) {
        delete newErrors.nomeTitolo;
      }

      if (name === "rilasciatoIl") {
        if (/^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
          delete newErrors.rilasciatoIl;
        }
      }

      if (name === "da" && value.trim()) {
        delete newErrors.da;
      }

      if (name === "idTipologiaTitolo" && !isNaN(value) && value !== "") {
        delete newErrors.idTipologiaTitolo;
      }

      return newErrors;
    });
  };

  const validate = () => {
    const inputErrors = {};

    if (!form.idTipologiaTitolo || isNaN(form.idTipologiaTitolo)) {
      inputErrors.idTipologiaTitolo =
        "La tipologia del titolo non può essere vuota!";
    }

    if (!form.nomeTitolo.trim()) {
      inputErrors.nomeTitolo = "Il nome del titolo non può essere vuoto!";
    }

    if (!form.rilasciatoIl.trim()) {
      inputErrors.rilasciatoIl = "La data di rilascio non può essere vuota!";
    } else if (!/^\d{4}-\d{2}-\d{2}$/.test(form.rilasciatoIl.trim())) {
      inputErrors.rilasciatoIl = "La data deve essere nel formato YYYY-MM-DD.";
    }

    if (!form.da.trim()) {
      inputErrors.da = "Il campo 'Da' non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      const response = await api.put(`/titoli-studio/${id}`, {
        idTipologiaTitolo: form.idTipologiaTitolo,
        nomeTitolo: form.nomeTitolo,
        rilasciatoIl: form.rilasciatoIl,
        da: form.da,
      });

      if (response.status === 200) {
        toast.success("Modifiche salvate con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setTitoliStudi({
          ...titoliStudi,
          ...form,
          tipologiaTitolo: tipologiaTitoli.find(
            (t) => t.idTipologiaTitolo === form.idTipologiaTitolo
          ),
        });
        setEditMode(false);
      } else {
        toast.error("Errore durante il salvataggio!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (titoliStudi) {
      setForm({
        idTipologiaTitolo: titoliStudi.tipologiaTitolo?.idTipologiaTitolo || "",
        nomeTitolo: titoliStudi.nomeTitolo || "",
        rilasciatoIl: titoliStudi.rilasciatoIl || "",
        da: titoliStudi.da || "",
      });
    }
    setErrors({});
    setEditMode(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const isoDatePart = dateString.slice(0, 10);
    const [year, month, day] = isoDatePart.split("-");
    if (!year || !month || !day) return "";

    return `${day}.${month}.${year}`;
  };

  return (
    <div className="edit-titoli-studi-modern-bg">
      {loading && (
        <div className="edit-titoli-studi-modern-overlay">
          <div className="edit-titoli-studi-modern-spinner"></div>
        </div>
      )}
      <div className="edit-titoli-studi-modern-card">
        <div className="edit-titoli-studi-modern-header">
          <button
            onClick={() => navigate("/titoli-studi")}
            className="edit-titoli-studi-modern-back"
            title="Torna indietro"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2>
            <i className="fa-solid fa-graduation-cap"></i>
            Modifica Titolo di Studio
          </h2>
          {!editMode && (
            <button
              className="edit-titoli-studi-modern-edit"
              onClick={() => setEditMode(true)}
            >
              <i className="fa-solid fa-pen"></i>
              Modifica
            </button>
          )}
        </div>
        <form
          className="edit-titoli-studi-modern-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <div className="edit-titoli-studi-modern-fields">
            <div className="edit-titoli-studi-modern-field">
              <label className="edit-titoli-studi-modern-label">
                <i className="fa-solid fa-layer-group"></i>
                Tipologia Titolo
              </label>
              {editMode ? (
                <CustomSelect
                  name="idTipologiaTitolo"
                  options={tipologiaTitoli.map((tipo) => ({
                    value: tipo.idTipologiaTitolo,
                    label: tipo.titoloTipologia,
                  }))}
                  value={
                    form.idTipologiaTitolo
                      ? {
                          value: form.idTipologiaTitolo,
                          label: tipologiaTitoli.find(
                            (t) =>
                              t.idTipologiaTitolo === form.idTipologiaTitolo
                          )?.titoloTipologia,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleChange({
                      target: {
                        name: "idTipologiaTitolo",
                        value: selected ? selected.value : "",
                      },
                    })
                  }
                  placeholder="-- Seleziona tipologia --"
                />
              ) : (
                <span className="edit-titoli-studi-modern-text">
                  {titoliStudi?.tipologiaTitolo?.titoloTipologia || "-"}
                </span>
              )}
              {errors.idTipologiaTitolo && (
                <span className="edit-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.idTipologiaTitolo}
                </span>
              )}
            </div>
            <div className="edit-titoli-studi-modern-field">
              <label className="edit-titoli-studi-modern-label">
                <i className="fa-solid fa-certificate"></i>
                Nome Titolo
              </label>
              {editMode ? (
                <input
                  id="nomeTitolo"
                  name="nomeTitolo"
                  type="text"
                  value={form.nomeTitolo}
                  onChange={handleChange}
                  className={errors.nomeTitolo ? "error" : ""}
                  placeholder="Nome Titolo"
                />
              ) : (
                <span className="edit-titoli-studi-modern-text">
                  {titoliStudi?.nomeTitolo || "-"}
                </span>
              )}
              {errors.nomeTitolo && (
                <span className="edit-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.nomeTitolo}
                </span>
              )}
            </div>
            <div className="edit-titoli-studi-modern-field">
              <label className="edit-titoli-studi-modern-label">
                <i className="fa-solid fa-calendar-plus"></i>
                Rilasciato Il
              </label>
              {editMode ? (
                <input
                  id="rilasciatoIl"
                  name="rilasciatoIl"
                  type="date"
                  value={form.rilasciatoIl}
                  onChange={handleChange}
                  className={errors.rilasciatoIl ? "error" : ""}
                  placeholder="YYYY-MM-DD"
                />
              ) : (
                <span className="edit-titoli-studi-modern-text">
                  {formatDate(titoliStudi?.rilasciatoIl) || "-"}
                </span>
              )}
              {errors.rilasciatoIl && (
                <span className="edit-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.rilasciatoIl}
                </span>
              )}
            </div>
            <div className="edit-titoli-studi-modern-field">
              <label className="edit-titoli-studi-modern-label">
                <i className="fa-solid fa-building-columns"></i>
                Da
              </label>
              {editMode ? (
                <input
                  id="da"
                  name="da"
                  type="text"
                  value={form.da}
                  onChange={handleChange}
                  className={errors.da ? "error" : ""}
                  placeholder="Ente o istituto di rilascio"
                />
              ) : (
                <span className="edit-titoli-studi-modern-text">
                  {titoliStudi?.da || "-"}
                </span>
              )}
              {errors.da && (
                <span className="edit-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.da}
                </span>
              )}
            </div>
          </div>
          {editMode && (
            <div className="edit-titoli-studi-modern-actions">
              <button
                type="button"
                className="edit-titoli-studi-modern-cancel"
                onClick={handleCancel}
              >
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button type="submit" className="edit-titoli-studi-modern-save">
                <i className="fa-solid fa-save"></i>
                Salva Modifica
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default EditTitoliStudi;
